import '../styles/main.scss'
import '@/lib/select.js'
import app from '@/app.js'
import { fetchCart } from '@/lib/cart.js'

import '@/lib/index-functions'

Promise.all([fetchCart()]).then(([cart]) => {
    /* Hent data fra kurven, og skyd derefter dataen ind i app-variablen */
    app.hydrate({ cart })

    /* Mount af alle components */
    app.mount()
})
